import styled from "styled-components/macro";
import { Grid } from "../../GlobalStyles.styles";

export const SmartKeysGrid = styled(Grid)`
  /* max-height: 270px; */
  /* max-height: 270px; */
  height: 100%;

  grid-template-areas:
    "wave2 hr"
    "smartkeys smartkeys";
  grid-template-rows: 20% 68%;
  grid-template-columns: 1fr;
  background: black;
  width: 100%;
  gap: 0.25em;
`;

export const SmartKeysGrid2 = styled(Grid)`
  max-height: 270px;
  grid-template-areas:
    /* "${({ secondary }) => (secondary ? "wave2" : "wave1")} hr" */
    "wave2 hr"
    "smartkeys smartkeys";

  grid-template-areas: ;
  grid-template-rows: 20% 68%;
  grid-template-columns: 1fr;
  background: black;
  /* width: 250px; */
`;

export const StandbyGrid = styled.div`
  height: 272px;
  width: 100%;
  /* margin-top: -1em; */
`;

export const SkTopLine = styled.div`
  background: var(--clr-settingstopbar);
  color: #edebeb;

  text-align: center;
  padding: 0.2em;
  position: relative;
  font-size: 0.8rem;
`;

export const SkWrapper = styled.div`
  grid-area: smartkeys;
  background: var(--clr-settingsbg);
  /* height: ${({ full }) => full && "276px"}; */
  height: 101.4%;
`;
export const SkClose = styled.div`
  color: #edebeb;
  position: absolute;
  top: 10%;
  right: 0;
`;

export const SkBox = styled(Grid)`
  /* margin-top: 1em; */
  padding-top: 1em;
  color: #edebeb;
  /* font-size: 1em; */
  font-size: 0.8rem;

  background: var(--clr-settingsbg);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: grid;
  grid-template-areas:
    "spo2 device"
    "standby mainsetup"
    "ecg trends"
    "alarms print"
    "opmodes lock";

  * {
    color: #edebeb;
  }
  ::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-track {
    background-color: inherit; /* Color of the track */
  }

  ::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 5px; /* Rounded corners of the thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Color of the thumb on hover */
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #000; /* Color of the thumb when active */
  }
  font-weight: bolder;
`;

export const SkboxItem = styled.div`
  padding: 0 1em;
  text-align: center;
`;

export const SkboxButton = styled.button`
  padding: 0 1em;
  text-align: center;
  background: none;
  height: 100%;
  width: 100%;
  padding-top: 1em;
`;

export const SkIconWrapper = styled.div`
  /* font-size: 1.75rem; */
  font-size: 1.75rem;
`;

export const SkboxTitle = styled.div`
  margin-top: 0.5em;
`;
